/**
 * Public, token-authenticated portal for external (non-ClinVea) referral recipients — backs
 * /external-referral/:token. No login: the token in the URL is the access grant (mirrors the
 * existing consent-QR and shared-prescription public flows). Backs
 * ExternalPortalController on the server.
 */
import { fetchApi } from '../client';
import type { ClinicalUrgency, ReferralStatus } from './clinicalReferrals';

export interface RecordPackageSection {
  title: string;
  content: string;
}

export interface ExternalPortalView {
  referralNumber: string;
  status: ReferralStatus;
  urgency: ClinicalUrgency;
  specialty?: string;
  referralReason: string;
  requestedService?: string;
  referringClinicName?: string;
  referringProviderName?: string;
  patientName?: string;
  patientAge?: number;
  patientGender?: string;
  recordPackage: RecordPackageSection[];
  canAccept: boolean;
  canDecline: boolean;
  canRequestMoreInfo: boolean;
  expiresAt?: string;
}

const BASE = '/api/external-referral-portal';

export const externalReferralPortalModule = {
  view: (token: string) =>
    fetchApi<ExternalPortalView>(`${BASE}/${token}`),

  accept: (token: string) =>
    fetchApi<void>(`${BASE}/${token}/accept`, { method: 'POST' }),

  decline: (token: string, reason?: string) =>
    fetchApi<void>(`${BASE}/${token}/decline`, { method: 'POST', body: JSON.stringify({ reason }) }),

  requestMoreInfo: (token: string, reason: string) =>
    fetchApi<void>(`${BASE}/${token}/request-more-info`, { method: 'POST', body: JSON.stringify({ reason }) }),
};
